ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
Promise = require 'bluebird'
_ = require 'underscore'

API_MESSAGES_TO_RESULT_CODES =
  COMMON:
    'unknown': 'unknown'
    'email restricted': 'restricted'
    'not found': 'not-found'
    'unauthorized permission requested': 'unauthorized'
  ADD:
    'must first transfer account': 'add:must-transfer'
    'must reactivate': 'add:must-reactivate'
    'already invited': 'add:existing'
    'already in organization': 'add:existing'
    'success': 'add:added'
    'no enterprise licenses': 'add:no-licenses'
  REMOVE:
    'success': 'remove:removed'
    'remove deactivated member from only': 'remove:deactivated'
    'not enough admins': 'remove:not-enough-admins'
  DEACTIVATE:
    'success': 'deactivate:deactivated'
    'cannot deactivate yourself': 'deactivate:cannot-deactivate-yourself'
    'not enough admins': 'deactivate:not-enough-admins'

reduceResultsMap = (results) ->
  _.groupBy(results, 'status')

errorToResultCode = (error, apiMessagesToResultCodes) ->
  errorMessage = error.message.toLowerCase()

  apiMessagesToResultCodesWithCommons = _.extend {}, API_MESSAGES_TO_RESULT_CODES.COMMON, apiMessagesToResultCodes

  status = _.find apiMessagesToResultCodesWithCommons, (resultCode, apiMessage) ->
    errorMessage.indexOf(apiMessage) > -1

  status || API_MESSAGES_TO_RESULT_CODES.COMMON.unknown

apiCall = (apiCallParams, apiMessagesToResultCodes, member, afterEach) ->
  ApiPromise(apiCallParams)
    .then (response) ->
      status = apiMessagesToResultCodes['success']
      afterEach(member, status, response)
      status
    .catch ApiError, (error) ->
      status = errorToResultCode(error, apiMessagesToResultCodes)
      afterEach(member, status)
      status
    .then (status) ->
      { status, member }

removeMembers = (team, members, afterEach, removeFromBoards, concurrency) ->
  Promise.map members, (member) =>
    apiCallParams =
      method: 'delete'
      url: "/1/organizations/#{ team.get('name') }/members/#{ member.id }"

    if team.getMembershipFor(member).deactivated || removeFromBoards
      apiCallParams.url = apiCallParams.url + '/all'

    apiCall apiCallParams, API_MESSAGES_TO_RESULT_CODES.REMOVE, member,
      afterEach

  , { concurrency }

module.exports.addToTeam = (team, members, afterEach, { concurrency }) ->
  Promise.map members, (member) =>
    apiCallParams =
      method: 'post'
      url: "/1/organizations/#{ team.get('name') }/memberships"
      data:
        idMember: member.id
        type: 'normal'
    apiCall(apiCallParams, API_MESSAGES_TO_RESULT_CODES.ADD, member, afterEach)
  , { concurrency }
  .then(reduceResultsMap)

module.exports.removeFromTeam = (team, members, afterEach, { concurrency, removeFromBoards }) ->
  nonAdmins = _.filter members, (member) ->
    team.getMemberType(member.toBackbone()) != 'admin'

  admins = _.difference members, nonAdmins
  # Make sure the currently logged in member is always the last member to be
  # removed, if he is on the list of admins. This is important to guarantee
  # that he won't be first removed then re-added to the team if we remove
  # the last team admin after removing himself. (Note that: false < true)
  admins = _.sortBy admins, (admin) -> Auth.isMe(admin)

  removeMembers(team, nonAdmins, afterEach, removeFromBoards, { concurrency })
  .then (nonAdminsResults) ->
    # If we remove members concurrently we could run into a race condition that
    # could result into the removal of the last two org admins, making the org
    # admin-less, which should not be possible.
    removeMembers(team, admins, afterEach, removeFromBoards, 1)
    .then (adminsResults) ->
      results = nonAdminsResults.concat(adminsResults)
      reduceResultsMap(results)

module.exports.deactivateFromTeam = (team, members, afterEach, { concurrency }) ->
  Promise.map members, (member) =>
    apiCallParams =
      method: 'put'
      url: "/1/organizations/#{ team.id }/members/#{ member.id }/deactivated"
      data:
        value: true

    apiCall apiCallParams, API_MESSAGES_TO_RESULT_CODES.DEACTIVATE, member,
      afterEach

  , { concurrency }
  .then(reduceResultsMap)



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/bulk-actions/bulk-actions.coffee